import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from 'lodash';
import getCountriesOptions from 'modules/Taps/utils/getCountriesOptions';

// создайте «конструктор селекторов», который использует lodash.isEqual вместо ===
export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const INDIVIDUAL_APPLICANT = 1;
const appSelect = (state) => state.app;
const routerSelect = (state) => state.router;
const tapsSelect = (state) => state.taps;
const profileSelect = (state) => state.profile;

// App state selectors
export const selectUser = createSelector(appSelect, ({ user }) => user);
export const selectUserData = createSelector(appSelect, ({ user }) => user.getIn(['data']));
export const selectUserLoading = createSelector(appSelect, ({ user }) => user.getIn(['loading']));
export const selectAvatar = createSelector(appSelect, ({ avatar }) => avatar);
export const selectLkIp = createSelector(appSelect, ({ lkIp }) => lkIp);
export const selectShowSearch = createSelector(
  appSelect,
  ({ searchModal: { showSearch } }) => showSearch,
);
export const selectBodyClass = createSelector(appSelect, ({ accessibility }) =>
  accessibility.get('bodyClass'),
);
export const selectShowTour = createSelector(appSelect, ({ showTour }) => showTour);
export const selectUserInn = createSelector(selectUser, (user) => user.getIn(['data', 'inn']));

export const selectSigner = createSelector(selectUser, (user) => ({
  signerType: INDIVIDUAL_APPLICANT,
  signerEmail: user.getIn(['data', 'email']),
  signerInn: user.getIn(['data', 'inn']),
}));

export const selectUserEmail = createSelector(selectUser, (user) => user.getIn(['data', 'email']));

// Router state selectors
export const selectRouter = createSelector(routerSelect, (router) => router);

export const selectRouterCardId = createSelector(routerSelect, ({ query: { cardId } }) => cardId);

export const selectRouterShowYear = createSelector(
  routerSelect,
  ({ query: { showYear } }) => showYear,
);

export const selectRouterDeclarationId = createSelector(
  routerSelect,
  ({ query: { declarationId } }) => declarationId,
);

export const selectFiasAddress = createSelector(tapsSelect, ({ fiasAddress }) => fiasAddress);

export const selectCertificateInfo = createSelector(
  tapsSelect,
  ({ certificateInfo }) => certificateInfo,
);

export const selectContactInfo = createSelector(profileSelect, ({ contactInfo }) => contactInfo);

export const selectSnus = createSelector(tapsSelect, ({ snus }) => snus);

export const selectPropertyObjects = createSelector(
  appSelect,
  ({ propertyObjects }) => propertyObjects,
);

export const selectCountries = createSelector(tapsSelect, ({ countries }) => countries);
export const selectCountriesLoading = createSelector(selectCountries, (countries) =>
  countries.get('loading'),
);
export const selectCountriesError = createSelector(selectCountries, (countries) =>
  countries.get('error'),
);

export const selectCountriesOptions = createSelector(selectCountries, (countries) =>
  getCountriesOptions(countries.get('data'), ['643', '999']),
);

export const selectDocumentsTypes = createSelector(
  tapsSelect,
  ({ documentTypes }) => documentTypes,
);

export const selectDocumentsTypesOptions = createSelector(selectDocumentsTypes, (documentTypes) =>
  documentTypes.get('data')
    ? documentTypes.get('data').map(({ name, code }) => ({
        label: name,
        value: code,
      }))
    : [],
);

export const selectDocumentsTypesLoading = createSelector(selectDocumentsTypes, (data) =>
  data.get('loading'),
);

export const selectDocumentsTypesError = createSelector(selectDocumentsTypes, (data) =>
  data.get('error'),
);

export const selectBanners = createSelector(appSelect, ({ bannerList }) => bannerList);

export const selectSiteMap = createSelector(appSelect, ({ siteMap: { data } }) => data);
